import {ElasticValidation, ElasticValidator} from '../validator.factory';
import {dateGtRegExp, dateLtRegExp, dateRangeRegExp, dateRegExp} from '../../paser/parsers/date.parser';
import moment from 'moment';

export class DateValidator implements ElasticValidator {
  validate(dateString: string): ElasticValidation {
    if (dateString === undefined || dateString === null || dateString === '') {
      return {isInvalid: false};
    }

    dateString = dateString.trim();
    if (dateString === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const datesChunks = dateString.split('|')
      .map(dateChunk => dateChunk.trim())
      .filter(dateChunk => !!dateChunk);

    for (const datesChunk of datesChunks) {
      if (dateRegExp.test(datesChunk)) {
        const date = moment(datesChunk);

        if (!date?.isValid()) {
          return {isInvalid: true, errorMessage: `${datesChunk} is not a valid date`};
        }
      } else if (dateGtRegExp.test(datesChunk) || dateLtRegExp.test(datesChunk)) {
        const match = dateGtRegExp.exec(datesChunk) || dateLtRegExp.exec(datesChunk);
        const dateRegexString = match?.length > 0 && match[1];
        const date = moment(dateRegexString);

        if (!date?.isValid()) {
          return {isInvalid: true, errorMessage: `${datesChunk} is not a valid date`};
        }
      } else if (dateRangeRegExp.test(datesChunk)) {
        const match = dateRangeRegExp.exec(datesChunk);

        const dateRegexFromString = match?.length > 0 && match[1];
        const dateRegexToString = match?.length > 0 && match[3];

        const dateFrom = moment(dateRegexFromString);
        const dateTo = moment(dateRegexToString);

        if (!dateFrom?.isValid()) {
          return {isInvalid: true, errorMessage: `${dateRegexFromString} is not a valid date format`};
        } else if (!dateTo?.isValid()) {
          return {isInvalid: true, errorMessage: `${dateRegexToString} is not a valid date format`};
        } else if (dateFrom?.isAfter(dateTo)) {
          return {isInvalid: true, errorMessage: `${dateRegexFromString} is after ${dateRegexToString}`};
        }
      } else {
        return {isInvalid: true, errorMessage: `${datesChunk} is not a valid date format`};
      }
    }

    return {isInvalid: false};
  }
}
